export const LoginUrlBuilderConfig = Object.freeze({
  publicAuthRoute: '/auth/login',
  loginState: 'loginState',
  servicePath: 'servicePath',
  trazabilityCode: 'trazabilityCode',
  ticketId: 'ticketId',
});
